<div class="page-wrapper">
  <div class="authentication-box">
    <div class="container">
      <div class="row">

        <!-- Panel izquierdo (logo) -->
        <div class="col-md-5 card-left hub-center">
          <img src="../../../../assets/images/logo1.png" style="width:100%" alt="Learnify">
          <img src="../../../../assets/images/backoffice.png" style="width:100%" alt="">
        </div>

        <!-- Panel derecho (formulario) -->
        <div class="col-md-7 card-right">
          <div class="card tab2-card">
            <div class="card-body">

              <h4 class="signup-title">Crear cuenta</h4>
              <p class="signup-subtitle">
                Recibirás un correo para activar tu cuenta y establecer tu contraseña.
              </p>

              <!-- Mensaje de éxito -->
              <div *ngIf="successMessage" class="alert alert-success d-flex align-items-start gap-2">
                <i class="fa fa-check-circle mt-1"></i>
                <div>
                  <strong>¡Listo!</strong> {{ successMessage }}
                  <div class="mt-2">
                    <a href="javascript:void(0)" (click)="goToSignIn()" class="btn btn-sm btn-outline-success">
                      Ir a Iniciar sesión
                    </a>
                  </div>
                </div>
              </div>

              <!-- Mensaje de error -->
              <div *ngIf="errorMessage" class="alert alert-danger">
                <i class="fa fa-exclamation-circle me-1"></i> {{ errorMessage }}
              </div>

              <!-- Formulario -->
              <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()" class="form-horizontal auth-form needs-validation" novalidate>

                <!-- Nombre -->
                <div class="form-group">
                  <input
                    formControlName="firstName"
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'error': submitted && f['firstName'].invalid }"
                    placeholder="Nombre(s)">
                  <small *ngIf="submitted && f['firstName'].hasError('required')" class="text-danger">
                    El nombre es requerido.
                  </small>
                </div>

                <!-- Apellidos -->
                <div class="form-group">
                  <input
                    formControlName="lastName"
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'error': submitted && f['lastName'].invalid }"
                    placeholder="Apellido(s)">
                  <small *ngIf="submitted && f['lastName'].hasError('required')" class="text-danger">
                    El apellido es requerido.
                  </small>
                </div>

                <!-- Correo electrónico -->
                <div class="form-group">
                  <input
                    formControlName="email"
                    type="email"
                    class="form-control"
                    [ngClass]="{ 'error': submitted && f['email'].invalid }"
                    placeholder="Correo electrónico">
                  <small *ngIf="submitted && f['email'].hasError('required')" class="text-danger">
                    El correo es requerido.
                  </small>
                  <small *ngIf="submitted && f['email'].hasError('email')" class="text-danger">
                    Ingresa un correo válido.
                  </small>
                </div>

                <!-- Tipo de cuenta -->
                <div class="form-group">
                  <label class="role-label">Tipo de cuenta</label>
                  <div class="role-selector">
                    <label
                      class="role-option"
                      [class.role-option--active]="f['roles'].value === 'student'">
                      <input type="radio" formControlName="roles" value="student" />
                      <span class="role-option__icon">🎓</span>
                      <span class="role-option__text">
                        <strong>Alumno</strong>
                        <small>Accede y consume contenido educativo</small>
                      </span>
                    </label>
                    <label
                      class="role-option"
                      [class.role-option--active]="f['roles'].value === 'teacher'">
                      <input type="radio" formControlName="roles" value="teacher" />
                      <span class="role-option__icon">🚀</span>
                      <span class="role-option__text">
                        <strong>Negocio / Creador</strong>
                        <small>Crea y vende tus infoproductos</small>
                      </span>
                    </label>
                  </div>
                </div>

                <!-- Botón enviar -->
                <div class="form-button mt-3">
                  <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    <span>{{ isLoading ? 'Creando cuenta...' : 'Crear cuenta' }}</span>
                  </button>
                </div>

                <!-- Enlace login -->
                <div class="text-center mt-3">
                  <span class="text-muted">¿Ya tienes cuenta? </span>
                  <a href="javascript:void(0)" (click)="goToSignIn()">Iniciar sesión</a>
                </div>

              </form>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
